import { useRPC } from "../../../hooks/useRPC/index.js";
import { RPCs } from "@therms/rpc-gateway";
//#region src/modules/Locations/hooks/useLocationLogEntryTypesByIds.ts
/**
* Get a list of EntryTypes.
*
* Note: data does not include the FormBuilder schema
*
* @param args
* @param opts
*/
function useLocationLogEntryTypesByIds(args, opts = {}) {
	const { call, data, isCalling } = useRPC(RPCs.Locations.GetLocationLogEntryTypesList.v1, args, {
		cacheStrategy: opts.cacheStrategy,
		fire: !!args?.entryTypeIds?.length
	});
	return {
		data,
		loading: isCalling,
		refresh: call
	};
}
//#endregion
export { useLocationLogEntryTypesByIds };

//# sourceMappingURL=useLocationLogEntryTypesByIds.js.map